import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["title", "desc", "children"];
import React from 'react';
import styled from 'styled-components';
var Base = /*#__PURE__*/styled.svg.withConfig({
  displayName: "Icon__Base",
  componentId: "sc-1i6vuca-0"
})(["color:", ";display:inline-block;fill:none;height:", ";line-height:1em;vertical-align:middle;width:", ";"], function (_ref) {
  var color = _ref.color;
  return color !== null && color !== void 0 ? color : 'currentColor';
}, function (_ref2) {
  var height = _ref2.height;
  return height !== null && height !== void 0 ? height : '1em';
}, function (_ref3) {
  var width = _ref3.width;
  return width !== null && width !== void 0 ? width : '1em';
});
var FallbackIcon = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  fill: "none",
  d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  strokeLinecap: "round",
  d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  strokeMiterlimit: "10",
  cx: "12",
  cy: "12",
  r: "11.25"
}));
export var Icon = function Icon(_ref4) {
  var title = _ref4.title,
      desc = _ref4.desc,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(Base, _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), children !== null && children !== void 0 ? children : FallbackIcon);
};